import styled, { css, keyframes } from 'styled-components'

const messageIn = keyframes`
  from { 
    opacity: 0;
    transform: translateY(100px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`

const messageOut = keyframes`
  from { 
    opacity: 1;
    transform: translateY(0);
  }
  to { 
    opacity: 0;
    transform: translateY(100px);
  }
`

const containerVariant = {
  default: css`
    background: ${({ theme }) => theme.colors.primary.main};
  `,
  success: css`
    background: ${({ theme }) => theme.colors.success.main};
  `,
  danger: css`
    background: ${({ theme }) => theme.colors.danger.main};
  `,
}

export const Container = styled.div`
  padding: 16px 32px;
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 20px 20px -16px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  animation: ${messageIn} .3s;

  ${({ isLeaving }) =>
    isLeaving &&
    css`
      animation: ${messageOut} .2s forwards;
    `}

  ${({ type }) => containerVariant[type] || containerVariant.default}

  & ~ & {
    margin-top: 12px;
  }
`
